export const Footer = () => {
  return (
    <footer className="root__footer footer">
      <a href="https://planx.one/">Разработка Planx.one</a>
    </footer>
  );
};
